export default "__VITE_ASSET__DpyrTfkt__"